var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import FetchService from "./Shared/FetchService";
import StudentSearchService from "../Domain/StudentSearch/StudentSearch.service";
const BASE_URL = "/aviso/population";
export default class PopulationService {
    static membersForPersonPopulation({ populationId, tempVals = {}, query, max, offset, }) {
        return FetchService.postPagedResponse(BASE_URL + "/membersForPersonPopulation", {
            populationId,
            tempVals: Object.assign(Object.assign({}, tempVals), { query }),
            max,
            offset,
        });
    }
    static getPersonPopulationNamesForUserAsOwner({ personId, personTypeInternalName, }) {
        return FetchService.getSingleResponse(BASE_URL + "/getPersonPopulationNamesForUserAsOwner", {
            personId,
            personTypeInternalName,
        });
    }
    static countForPersonPopulation(populationId, { tempVals, query, } = {}) {
        return __awaiter(this, void 0, void 0, function* () {
            // I really don't want to rewrite the membersForPersonPopulation function, so for now, this requests
            // the members of that population, but just one person (to make it a bit more performant) and returns the total count.
            const members = yield PopulationService.membersForPersonPopulation({
                populationId,
                tempVals,
                query,
                max: 1,
                offset: 0,
            });
            return members.total;
        });
    }
    static get(populationId) {
        return FetchService.getSingleResponse(BASE_URL + "/get", {
            populationId,
        });
    }
    static getCaseloadsSelectionForFilterBackedPopulation(populationId) {
        return FetchService.getSingleResponse(BASE_URL + "/getCaseloadsSelectionForFilterBackedPopulation", { populationId });
    }
    static getPersonPopulationsForUser(personTypeInternalName, query) {
        return FetchService.getSingleResponse(BASE_URL + "/getPersonPopulationsForUser", { query, personTypeInternalName });
    }
    static getBulkPersonPopulationPermissionsForCurrentUser(personPopulationIds) {
        return FetchService.postSingleResponse(BASE_URL + "/getBulkPersonPopulationPermissionsForCurrentUser", { personPopulationIds });
    }
    static getPeopleSharedWith({ populationId, max, offset, }) {
        return FetchService.getPagedResponse(BASE_URL + "/getPeopleSharedWith", {
            populationId,
            offset,
            max,
        });
    }
    static search(populationSearch, options = {}) {
        return FetchService.getPagedResponse(BASE_URL + "/search", {
            ownerIds: populationSearch.ownerIds,
            query: populationSearch.query,
            createdBy: populationSearch.createdBy,
            isBasePopulation: populationSearch.isBasePopulation,
            personTypeIds: populationSearch.personTypeIds,
            personTypeInternalNames: populationSearch.personTypeInternalNames,
            allPopulations: populationSearch.allPopulations,
            adHoc: populationSearch.adHoc,
            max: options.max,
            offset: options.offset,
            sort: options.sort,
            order: options.order,
        });
    }
    static getStudentSearchValuesFromFilterBackedPopulation(populationId) {
        return FetchService.get(BASE_URL + "/getStudentSearchValuesFromFilterBackedPopulation", {
            populationId,
        }).then(({ population, studentSearchValues }) => ({
            population,
            studentSearchValues: StudentSearchService.fromJSON(studentSearchValues),
        }));
    }
    static getDefaultPopulationId(personTypeInternalName) {
        return __awaiter(this, void 0, void 0, function* () {
            return FetchService.getSingleResponse(BASE_URL + "/getEveryonePopulationId", {
                personTypeInternalName,
            });
        });
    }
    static getDefaultPopulationsForCurrentUser(personTypeInternalName) {
        return FetchService.getSingleResponse(BASE_URL + "/getDefaultPopulationsForCurrentUser", {
            personTypeInternalName,
        });
    }
    static getPopulationCount(populationId) {
        return FetchService.getSingleResponse(BASE_URL + "/populationCount", {
            populationId,
        });
    }
    static saveFilterBackedPopulation(populationId, filterRequest) {
        return FetchService.postSingleResponse(BASE_URL + "/saveFilterBackedPopulation", { populationId, filterRequest });
    }
    static delete(populationId) {
        return FetchService.deleteSingleResponse(BASE_URL + "/delete", {
            populationId,
        });
    }
    static copy(populationId) {
        return FetchService.getSingleResponse(BASE_URL + "/copy", {
            populationId,
        });
    }
    static toExcel(populationId) {
        return FetchService.getSingleResponse(BASE_URL + "/toExcel", {
            populationId,
        });
    }
    static updateSharingSettings(request) {
        return FetchService.postSingleResponse(BASE_URL + "/updateSharingSettings", Object.assign({}, request));
    }
    static getSharingSettings(populationId) {
        return FetchService.getSingleResponse(BASE_URL + "/getSharingSettings", {
            populationId,
        });
    }
    static changeOwner(populationId, personId) {
        return FetchService.postSingleResponse(BASE_URL + "/changeOwner", {
            populationId,
            personId,
        });
    }
    static getMembersOfPopulations(populationIds) {
        return FetchService.postSingleResponse(BASE_URL + "/getMembersOfPopulations", {
            populationIds,
        });
    }
    static getSuperLite(populationId) {
        return FetchService.getSingleResponse(BASE_URL + "/getSuperLite", {
            populationId,
        });
    }
}
